import type { Translate } from '@/utils/hooks/translation/useTranslation';

export const languages_available = (t: Translate) =>
    [
        { label: t('language:language_af'), value: 'af' },
        { label: t('language:language_sq'), value: 'sq' },
        { label: t('language:language_am'), value: 'am' },
        { label: t('language:language_ar'), value: 'ar' },
        { label: t('language:language_hy'), value: 'hy' },
        { label: t('language:language_az'), value: 'az' },
        { label: t('language:language_bn'), value: 'bn' },
        { label: t('language:language_bs'), value: 'bs' },
        { label: t('language:language_bg'), value: 'bg' },
        { label: t('language:language_ca'), value: 'ca' },
        { label: t('language:language_zh'), value: 'zh' },
        { label: t('language:language_hr'), value: 'hr' },
        { label: t('language:language_cs'), value: 'cs' },
        { label: t('language:language_da'), value: 'da' },
        { label: t('language:language_nl'), value: 'nl' },
        { label: t('language:language_en'), value: 'en' },
        { label: t('language:language_et'), value: 'et' },
        { label: t('language:language_fa'), value: 'fa' },
        { label: t('language:language_tl'), value: 'tl' },
        { label: t('language:language_fi'), value: 'fi' },
        { label: t('language:language_fr'), value: 'fr' },
        { label: t('language:language_ka'), value: 'ka' },
        { label: t('language:language_de'), value: 'de' },
        { label: t('language:language_el'), value: 'el' },
        { label: t('language:language_gu'), value: 'gu' },
        { label: t('language:language_ht'), value: 'ht' },
        { label: t('language:language_ha'), value: 'ha' },
        { label: t('language:language_he'), value: 'he' },
        { label: t('language:language_hi'), value: 'hi' },
        { label: t('language:language_hu'), value: 'hu' },
        { label: t('language:language_is'), value: 'is' },
        { label: t('language:language_id'), value: 'id' },
        { label: t('language:language_it'), value: 'it' },
        { label: t('language:language_ja'), value: 'ja' },
        { label: t('language:language_kn'), value: 'kn' },
        { label: t('language:language_kk'), value: 'kk' },
        { label: t('language:language_ko'), value: 'ko' },
        { label: t('language:language_lv'), value: 'lv' },
        { label: t('language:language_lt'), value: 'lt' },
        { label: t('language:language_mk'), value: 'mk' },
        { label: t('language:language_ms'), value: 'ms' },
        { label: t('language:language_ml'), value: 'ml' },
        { label: t('language:language_mt'), value: 'mt' },
        { label: t('language:language_mn'), value: 'mn' },
        { label: t('language:language_no'), value: 'no' },
        { label: t('language:language_fa'), value: 'fa' },
        { label: t('language:language_ps'), value: 'ps' },
        { label: t('language:language_pl'), value: 'pl' },
        { label: t('language:language_pt'), value: 'pt' },
        { label: t('language:language_ro'), value: 'ro' },
        { label: t('language:language_ru'), value: 'ru' },
        { label: t('language:language_sr'), value: 'sr' },
        { label: t('language:language_si'), value: 'si' },
        { label: t('language:language_sk'), value: 'sk' },
        { label: t('language:language_sl'), value: 'sl' },
        { label: t('language:language_so'), value: 'so' },
        { label: t('language:language_es'), value: 'es' },
        { label: t('language:language_sw'), value: 'sw' },
        { label: t('language:language_sv'), value: 'sv' },
        { label: t('language:language_tl'), value: 'tl' },
        { label: t('language:language_ta'), value: 'ta' },
        { label: t('language:language_te'), value: 'te' },
        { label: t('language:language_th'), value: 'th' },
        { label: t('language:language_tr'), value: 'tr' },
        { label: t('language:language_uk'), value: 'uk' },
        { label: t('language:language_ur'), value: 'ur' },
        { label: t('language:language_uz'), value: 'uz' },
        { label: t('language:language_vi'), value: 'vi' },
        { label: t('language:language_cy'), value: 'cy' }
    ] as const;
